import { useState, useEffect} from 'react'
import { getGeolocation, getLocationData } from '../../context/location/MapActions';
import MapsLoader from '../partials/MapsLoader';
import DistanceInfo from '../map/DistanceInfo';

function LocateUs() {

    const [userLocation, setUserLocation] = useState(null);
    const [loading, setLoading] = useState(true);




    useEffect(() => {
        if (navigator.geolocation) {
            getGeolocation().then(res => {
                if(res !== null && res !== undefined){
                    const lat = res.lat;
                    const lng = res.lng;
                    getLocationData({lat, lng}).then(response => {
                        if(response !== undefined && response !== null){
                            setUserLocation(
                                response.data
                            );
                        }
                    });
                }
                setLoading(false);
            });

        }else{
            setLoading(false);
            alert('Geolocation not supported on your browser')
        }
        
    }, []);


    if(loading) return <div>Loading...</div>;

    return (
        <MapsLoader fallback={<div>Loading map scripts...</div>}>
            <DistanceInfo userLocation={userLocation} />
        </MapsLoader>
    );
    
}


export default LocateUs
